// Generated types for SysMLBehavior
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLClassifierReadAPI, SysMLClassifierWriteAPI } from './sysmlclassifier';
import { SysMLClassifierReadAPISchemaObject, SysMLClassifierWriteAPISchemaObject } from './sysmlclassifier';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLBehaviorReadAPI extends SysMLClassifierReadAPI {
}

export interface SysMLBehaviorWriteAPI extends SysMLClassifierWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLBehaviorReadAPISchemaObject = SysMLClassifierReadAPISchemaObject.extend({}).passthrough();
export const SysMLBehaviorReadAPISchema: z.ZodType<SysMLBehaviorReadAPI> = SysMLBehaviorReadAPISchemaObject;

export const SysMLBehaviorWriteAPISchemaObject = SysMLClassifierWriteAPISchemaObject.extend({}).passthrough();
export const SysMLBehaviorWriteAPISchema: z.ZodType<SysMLBehaviorWriteAPI> = SysMLBehaviorWriteAPISchemaObject;
